/**
 * Google Maps Custom Styles for BamakoFuel Web App
 * Using Google Cloud Map Style ID: 37c7369426a8bd686acb0aea
 */

export const GOOGLE_MAPS_API_KEY = 'AIzaSyC4MywrpBltItx9VxACxBKfIyRIz0vj7UE';

export const CUSTOM_MAP_STYLE = {
  // For Google Maps JavaScript API, we use the Google Cloud Map ID
  // This references your custom map created in Google Cloud Console
  mapId: '37c7369426a8bd686acb0aea'
};

// Fallback style array (if Google Cloud Map ID doesn't work)
export const FALLBACK_MAP_STYLE = [
  {
    "featureType": "administrative",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  }
];

export default CUSTOM_MAP_STYLE;